exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_essia[data-v-28f2155d]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:420px;padding:10px}.modal_essia>[data-v-28f2155d]{padding-left:0;padding-right:0;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28f2155d","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modalEssia/ModalEssia.vue
// module id = 13b38151d5ec51991ba8
// module chunks = 0